import { financeAPI } from "../../axios";

export const actions = {
    AddSubscriberMeterReading(context, data){
        return financeAPI.post(`SubscriberMeterReading/Add`, data);
    },
    UpdateSubscriberMeterReading(context, data){
        return financeAPI.put(`SubscriberMeterReading/${data.id}`, data);
    },
    RemoveSubscriberMeterReading(context, data){
        return financeAPI.delete(`SubscriberMeterReading/${data}`);
    },
    GetSingleSubscriberMeterReading(context, data){
        return financeAPI.get(`SubscriberMeterReading/${data}`);
    },
    GetAllSubscriberMeterReading(context, data){
        return financeAPI.get(`SubscriberMeterReading/Subscriber/${data}`);
    },
    GetRangeSubscriberMeterReading(context, data){
        return financeAPI.post(`SubscriberMeterReading/Subscriber/Range/${data.id}`, data);
    },
    GetLatestSubscriberMeterReading(context, data){
        return financeAPI.get(`SubscriberMeterReading/Subscriber/Latest/${data}`);
    },
    PostSubscriberMeterReading(context, data){
        return financeAPI.post(`SubscriberMeterReading/Post/${data}`);
    },
    GetDraftSubscriberMeterReading(context, data){
        return financeAPI.get(`SubscriberMeterReading/Draft/Subscriber/${data}`);
    },
    GetUnpaidSubscriberMeterReading(context, data){
        return financeAPI.get(`SubscriberMeterReading/Unpaid/Subscriber/${data}`);
    },
    GetUnpaidSubscriberMeterReadingByDUService(context, data){
        return financeAPI.post(`SubscriberMeterReading/Unpaid/DeliveryUnitService/${data.id}`, data);
    },
    GetUnpaidSubscriberMeterReadingSummary(context, data){
        return financeAPI.get(`SubscriberMeterReading/Unpaid/Summary/${data}`);
    }
}